// k3s-development build target — the in-cluster nginx image for the dev k3s
// stack. The admin console is served at the ROOT of its OWN hostname
// (admin.<env>) since Story 37.20; it is no longer a path on the consolidated
// host, so NOTHING here may be relative.
//
// 37.16 set oauthBaseUrl/tenantAdminApiUrl to '' so HttpClient emitted
// same-origin paths (/admin-login, /admin/tenant) against the shared hostname.
// That is now WRONG and fails loudly: a relative /admin-login resolves against
// admin.<env>, hits the static-file nginx rather than the API, and returns
// **405 Method Not Allowed** (POST to static content). Absolute is mandatory.
//
// The cross-origin prerequisites are already in place:
//   - nginx CSP names auth.<env> in connect-src (frontend/nginx/admin-ui.conf)
//   - tenant-admin ADMIN_UI_ALLOWED_ORIGIN / identity ADMIN_UI_ORIGIN are
//     https://admin.<env> (they always were — the backend expected this)
//   - the Admin Application clients carry https://admin.<env> as a CORS origin
// Auth state is a Bearer token, not a cookie, so there is no SameSite concern.
export const environment = {
  production: false,
  envLong: 'development',
  oauthBaseUrl: 'https://auth.development.emjo-consulting.dk',
  tenantAdminApiUrl: 'https://auth.development.emjo-consulting.dk',
  callbackUrl: '',
  // 46.10 code review: pointed at the RETIRED /brand-site path mount. The
  // brand site moved to its own ianua.<env> hostname and the path entry was
  // dropped from the auth host, so the two in-product "Docs" links built
  // from this value (pages-editor + emails-editor -> ${brandSiteUrl}/docs/...)
  // fell through to emjo-login's SPA catch-all and served the SIGN-IN app at
  // 200 — a blank page, since that router has no wildcard route. Live-broken
  // in all three environments until this fix; the docs themselves were fine
  // at ianua.<env>/docs/*. The story's residue sweep could not see this: it
  // scanned the brand-site dist only, not consumers in other apps.
  // Consumers today (53.1): pages-editor + emails-editor (${brandSiteUrl}/docs/...)
  // and the sidebar Documentation link (${brandSiteUrl}/docs) — a host move
  // (53.7 on prod) must carry all three.
  brandSiteUrl: 'https://ianua.development.emjo-consulting.dk',
};
